var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
// styles
import styles from './EmailInput.module.scss';
// dls
import DlsTextField from '@/widgets/DlsTextFeild/DlsTextField';
import { RightActionTypes, TextFieldTypes, } from '@swiggy-private/dls-web-core/dist/components/TextField/types';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// widgets
import AsyncButton from '@/widgets/AsyncButton';
// helpers
import { validateEmail } from '@/helpers/utils';
const EmailInput = ({ onSubmit, onChange, email, errorText, onSsoLogin, }) => {
    const [isEmailValid, setIsEmailValid] = React.useState(false);
    const sendOtpHandler = () => __awaiter(void 0, void 0, void 0, function* () { return onSubmit(); });
    useEffect(() => {
        setIsEmailValid(validateEmail(email));
    }, [email]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis, className: styles.header }, "Get Started"),
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis, className: styles.subHeader }, "Login to your company"),
        React.createElement("div", { className: styles.emailContainer },
            React.createElement(DlsTextField, { textFieldDetails: {
                    value: email,
                    isDisabled: false,
                    type: TextFieldTypes.TEXT,
                    name: 'email-input',
                    label: 'Enter email id',
                    onChange,
                    attrs: { autoComplete: 'off' },
                    errorText,
                }, rightActionDetails: [
                    {
                        type: RightActionTypes.CLEAR,
                    },
                ] }),
            React.createElement(AsyncButton, { className: styles.button, variant: "primary", onClick: sendOtpHandler, isDisabled: !isEmailValid }, "Send OTP"))));
};
export default EmailInput;
